export const TEMPLATES_PATH = '/admin/templates';
export const BASELINE_TEMPLATES_PATH = `${TEMPLATES_PATH}/baseline`;
export const NEW_BASELINE_TEMPLATE_PATH = `${BASELINE_TEMPLATES_PATH}/new`;

/** The template's global id is base64 and may hold `+`, `/` or `=`, so it is encoded; the route decodes it. */
export const editBaselineTemplatePath = (id: string): string => `${BASELINE_TEMPLATES_PATH}/${encodeURIComponent(id)}/edit`;
